import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule, NgOption } from '@ng-select/ng-select';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { GamePlanService } from 'src/app/_clusters/services/game-plan.service';
import { LoginService } from 'src/app/_clusters/services/login.service';
import { Router } from '@angular/router';
import _ from 'underscore';
import { AnimationConfigWithPath } from 'lottie-web';
import * as lottie from 'lottie-web';
import moment from 'moment';

@Component({
  selector: 'app-steps',
  templateUrl: './steps.component.html',
  styleUrls: ['./steps.component.scss']
})
export class StepsComponent implements OnInit {
  previousGpstatus: any;
  selectGpStatus: any;
  gameplanPreviousStatus: any
  commonErrorMsg: any
  showErrorPopup: any  // 1 is for gp error popup and 2 is for exam status error
  gameplanStatusList: any = [];
  showGPModal: any;
  userType: any;
  allowUpdate: any
  scoreError: string = '';
  isFirstErrorSkip: boolean = false;
  isSecondErrorSkip: boolean = false;
  topic1: any = '';
  topic2: any = '';
  type: string = '';
  gpErrorMsg: any
  allSubjects: any = '';
  // Exam Schedules variables
  examErrorMsg: any
  statusDD = this.gamePlanService.getStatusSubject.asObservable();
  examStatusList: any = []
  audData: any = {
    id: 0, subject_id: 101, name: 'Auditing', nickName: 'AUD',
    img: 'https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Gameplan-Status/aud_Card.png',
    dropdownInfo: {
      exam_status_type: '',
      exam_status_id: null
    },
    nts_expire_date: null,
    prioritizeWarning: true
  };
  becData: any = {
    id: 0, subject_id: 102, name: 'Business', nickName: 'BEC',
    dropdownInfo: {
      exam_status_type: '',
      exam_status_id: null
    },
    img: 'https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Gameplan-Status/bec_card.png',
    nts_expire_date: null,
    prioritizeWarning: true


  };
  farData: any = {
    id: 0, subject_id: 103, name: 'Finance',
    nickName: 'FAR',
    dropdownInfo: {
      exam_status_type: '',
      exam_status_id: null
    },
    img: 'https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Gameplan-Status/far_card.png',
    nts_expire_date: null,
    prioritizeWarning: true


  };
  regData: any = {
    id: 0, subject_id: 104, name: 'Regulations',
    nickName: 'REG',
    dropdownInfo: {
      exam_status_type: '',
      exam_status_id: null
    },
    img: 'https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Gameplan-Status/reg_card.png',
    nts_expire_date: null,
    prioritizeWarning: true


  };
  selectExamStatus: any;
  selectedCard: number | null;
  step: any
  checkscore: any
  // subjects = [
  //   {
  //     id: 101,
  //     name: 'Auditing',
  //     nickName: 'AUD',
  //     img: 'https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Gameplan-Status/aud_Card.png',
  //     examStatus: '',
  //   },
  //   {
  //     id: 102,
  //     name: 'Business',
  //     nickName: 'BEC',
  //     img: 'https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Gameplan-Status/bec_card.png',
  //     examStatus: '',
  //   },
  //   {
  //     id: 103,
  //     name: 'Finance',
  //     nickName: 'FAR',
  //     img: 'https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Gameplan-Status/far_card.png',
  //     examStatus: '',
  //   },
  //   {
  //     id: 104,
  //     name: 'Regulations',
  //     nickName: 'REG',
  //     img: 'https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Gameplan-Status/reg_card.png',
  //     examStatus: '',
  //   },
  // ];

  // preparing_subjects = [
  //   {
  //     id: 105,
  //     name: 'preparingAuditing',
  //     nickName: 'AUD',
  //     img: 'https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Gameplan-Status/aud_Card.png',
  //     examStatus: '',
  //   },
  //   {
  //     id: 106,
  //     name: 'preparingBusiness',
  //     nickName: 'BEC',
  //     img: 'https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Gameplan-Status/bec_card.png',
  //     examStatus: '',
  //   },
  //   {
  //     id: 107,
  //     name: 'preparingFinance',
  //     nickName: 'FAR',
  //     img: 'https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Gameplan-Status/far_card.png',
  //     examStatus: '',
  //   },
  //   {
  //     id: 108,
  //     name: 'preparingRegulations',
  //     nickName: 'REG',
  //     img: 'https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Gameplan-Status/reg_card.png',
  //     examStatus: '',
  //   },
  // ];

  subject: any = '';
  // global variables 
  userData: any = {}
  isWelcome: any
  enableArrowButton: boolean = false
  monthLabels: {
    01: 'Jan', 02: 'Feb', 03: 'Mar', 04: 'Apr', 05: 'May', 06: 'Jun', 07: 'Jul', 08: 'Aug', 09: 'Sep', 10:
    'Oct', 11: 'Nov', 12: 'Dec'
  }
  currentMonth: any
  todayDay: any
  constructor(
    private store: Store<any>, private gamePlanService: GamePlanService, private loginService: LoginService, private router: Router, private dp: DecimalPipe) { }

  ngOnInit(): void { window.scroll({top:0,left:0,behavior:"smooth"});
    this.todayDay = moment().format("YYYY-MM-DD")
    this.getUserDetails()
    this.getGpStatusList()
    this.getUserExamSchedulingDetails()
    const date = new Date();
    this.currentMonth = date.toISOString().substr(0, 7);
  }
  ngAfterViewInit() {
    this.loadLottieAnimation();
  }


  getUserDetails() {
    this.gamePlanService.getStudentTotalDetails().subscribe((res: any) => {
      if (res && res.status) {
        this.userData = res.data[0]
        this.isWelcome = this.userData?.is_welcome
        this.step = this.userData?.is_welcome
        this.getStudentGameplanStatus(this.userData.email)
        if (this.isWelcome == 5) {
          this.router.navigateByUrl('/godfather-last-page');

        }
      }
    })


  }


  changeDropDown(modal) {
    // if (this.selectExamStatus == 4 || this.selectExamStatus == 7) {
    //   this.examErrorMsg = "Note that there is a mis-match between your Gameplan Status and your Subject Status. Please check and update your Subject Status!"
    //   this.showErrorPopup = 2
    //   modal.show()
    // }
    // else {
    if (this.selectedCard === 101) {
      this.audData.dropdownInfo = this.examStatusList.filter(res => res.exam_status_id * 1 === this.selectExamStatus * 1)[0]
      console.log(this.audData)
    } else if (this.selectedCard === 102) {
      this.becData.dropdownInfo = this.examStatusList.filter(res => res.exam_status_id * 1 === this.selectExamStatus * 1)[0]

    }
    else if (this.selectedCard === 103) {
      this.farData.dropdownInfo = this.examStatusList.filter(res => res.exam_status_id * 1 === this.selectExamStatus * 1)[0]

    }
    else if (this.selectedCard === 104) {
      this.regData.dropdownInfo = this.examStatusList.filter(res => res.exam_status_id * 1 === this.selectExamStatus * 1)[0]

    }
    // }
    this.enableArrowButton = true;
    this.selectExamStatus = null

  }
  getGpStatusList() {
    this.gamePlanService.getGpStatusList().subscribe((res: any) => {
      if (res && res.status) {
        this.gameplanStatusList = res.data.filter(
          (item) => item.gameplan_evaluation_confirmation_id !== 13
        );
        // console.log(this.gameplanStatusList, 'asdklfjl');
      }
    })
  }
  getStudentGameplanStatus(email) {
    let payload = {
      emailId: email
    }
    this.gamePlanService.getUserCurrentGpStatus(payload).subscribe((res: any) => {
      if (res && res.status) {
        if (res.data.length > 0) {
          this.selectGpStatus = this.previousGpstatus = res.data[0].gameplan_current_status_id

          this.getExamSchedulingDetails(this.selectGpStatus)

          this.enableArrowButton = true
        } else {
          this.enableArrowButton = false
        }
      }
    })
  }

  getExamSchedulingDetails(gpStatus) {
    let payload = {
      gamplanStatus: gpStatus,
      isStep: this.step
    }
    this.gamePlanService.getExamLandingSchedulingDetails(payload).subscribe((res: any) => {
      if (res && res.status) {
        this.examStatusList = res.data


      }
    })

  }

  async getUserExamSchedulingDetails() {

    await this.gamePlanService.getLandingExamSchedules().subscribe((res: any) => {
      if (res && res.status) {
        if (res.data.length > 0) {
          let appearedStatus = [4, 5, 6, 7]
          let unAppearedStatus = [1, 2, 3]
          res.data.filter(el => {
            if (el.subject_id == 101) {

              this.audData.date_of_exam = this.convertToDatetag(el.date_of_exam)

              this.audData.exam_status = el.exam_status;
              this.audData.exam_status_name = el.exam_status_type;
              this.audData.id = el.id;
              this.audData.score = el.score !== 0 ? el.score + '' : '';
              this.audData.exam_status_id = el.exam_status_id == 0 ? 1 : el.exam_status_id
              this.audData.nts_expire_date = el.txt_aud_expiry_date
              this.audData.expected_date = el.expected_date !== null ? el.expected_date : el.expected_date = "NA"
              if ((this.step == 3 && appearedStatus.includes(el.exam_status_id)) || (this.isWelcome == 3 && appearedStatus.includes(el.exam_status_id))) {
                this.audData.dropdownInfo.exam_status_type = el.exam_status_type;
                this.audData.dropdownInfo.exam_status_id = el.exam_status

              }
              else if (this.step == 4 && unAppearedStatus.includes(el.exam_status_id) || this.isWelcome == 4 && unAppearedStatus.includes(el.exam_status_id)) {
                this.audData.dropdownInfo.exam_status_type = el.exam_status_type;
                this.audData.dropdownInfo.exam_status_id = el.exam_status
                this.audData.prioritizeWarning = false


              }
              else {
                this.audData.dropdownInfo.exam_status_type = '';
                this.audData.dropdownInfo.exam_status_id = null


              }



            } else if (el.subject_id == 102) {
              this.becData.date_of_exam = this.convertToDatetag(el.date_of_exam)

              this.becData.exam_status = el.exam_status
              this.becData.id = el.id;
              this.becData.score = el.score + '';
              this.becData.exam_status_id = el.exam_status_id == 0 ? 1 : el.exam_status_id
              // this.becData.exam_status_name = el.exam_status_type;
              // this.becData.dropdownInfo.exam_status_type = el.exam_status_type;
              // this.becData.dropdownInfo.exam_status_id = el.exam_status

              this.becData.nts_expire_date = el.txt_bec_expiry_date
              this.becData.expected_date = el.expected_date !== null ? el.expected_date : el.expected_date = "NA"
              if ((this.step == 3 && appearedStatus.includes(el.exam_status_id)) || (this.isWelcome == 3 && appearedStatus.includes(el.exam_status_id))) {
                this.becData.dropdownInfo.exam_status_type = el.exam_status_type;
                this.becData.dropdownInfo.exam_status_id = el.exam_status

              } else if (this.step == 4 && unAppearedStatus.includes(el.exam_status_id) || this.isWelcome == 4 && unAppearedStatus.includes(el.exam_status_id)) {
                this.becData.dropdownInfo.exam_status_type = el.exam_status_type;
                this.becData.dropdownInfo.exam_status_id = el.exam_status
                this.becData.prioritizeWarning = false
              }
              else {
                this.becData.dropdownInfo.exam_status_type = '';
                this.becData.dropdownInfo.exam_status_id = null
              }


            } else if (el.subject_id == 103) {
              this.farData.date_of_exam = this.convertToDatetag(el.date_of_exam)

              this.farData.exam_status = el.exam_status;
              this.farData.id = el.id;
              this.farData.score = el.score + '';
              this.farData.exam_status_name = el.exam_status_type;
              this.farData.exam_status_id = el.exam_status_id == 0 ? 1 : el.exam_status_id
              // this.farData.dropdownInfo.exam_status_type = el.exam_status_type;
              // this.farData.dropdownInfo.exam_status_id = el.exam_status

              this.farData.nts_expire_date = el.txt_far_expiry_date
              this.farData.expected_date = el.expected_date !== null ? el.expected_date : el.expected_date = "NA"

              if ((this.step == 3 && appearedStatus.includes(el.exam_status_id)) || (this.isWelcome == 3 && appearedStatus.includes(el.exam_status_id))) {
                this.farData.dropdownInfo.exam_status_type = el.exam_status_type;
                this.farData.dropdownInfo.exam_status_id = el.exam_status
              } else if (this.step == 4 && unAppearedStatus.includes(el.exam_status_id) || this.isWelcome == 4 && unAppearedStatus.includes(el.exam_status_id)) {
                this.farData.dropdownInfo.exam_status_type = el.exam_status_type;
                this.farData.dropdownInfo.exam_status_id = el.exam_status
                this.farData.prioritizeWarning = false

              }
              else {
                this.farData.dropdownInfo.exam_status_type = '';
                this.farData.dropdownInfo.exam_status_id = null
              }


            }
            else if (el.subject_id == 104) {
              this.regData.date_of_exam = this.convertToDatetag(el.date_of_exam)

              this.regData.exam_status = el.exam_status;
              this.regData.id = el.id;
              this.regData.score = el.score + '';
              this.regData.exam_status_name = el.exam_status_type;
              // this.regData.exam_status = el.exam_status_type;
              // this.regData.dropdownInfo.exam_status_type = el.exam_status_type;
              // this.regData.dropdownInfo.exam_status_id = el.exam_status
              this.regData.exam_status_id = el.exam_status_id == 0 ? 1 : el.exam_status_id
              this.regData.nts_expire_date = el.txt_reg_expiry_date
              this.regData.expected_date = el.expected_date !== null ? el.expected_date : el.expected_date = "NA"
              if ((this.step == 3 && appearedStatus.includes(el.exam_status_id)) || (this.isWelcome == 3 && appearedStatus.includes(el.exam_status_id))) {
                this.regData.dropdownInfo.exam_status_type = el.exam_status_type;
                this.regData.dropdownInfo.exam_status_id = el.exam_status
              } else if (this.step == 4 && unAppearedStatus.includes(el.exam_status_id) || this.isWelcome == 4 && unAppearedStatus.includes(el.exam_status_id)) {
                this.regData.dropdownInfo.exam_status_type = el.exam_status_type;
                this.regData.dropdownInfo.exam_status_id = el.exam_status
                this.regData.prioritizeWarning = false

              }
              else {
                this.regData.dropdownInfo.exam_status_type = '';
                this.regData.dropdownInfo.exam_status_id = null
              }


            }
          });
        }
        else {
          this.audData.exam_status_id = 1
          this.becData.exam_status_id = 1
          this.regData.exam_status_id = 1
          this.farData.exam_status_id = 1
          this.enableArrowButton = false
          // console.log(this.enableArrowButton, '')

        }
        // console.log(this.audData.expected_date, this.becData.expected_date, this.regData.expected_date, this.farData.expected_date)


      }
    })

  }
  appearedExamScreen() {
    // console.log(this.selectGpStatus)
    let y = [7]
    let x = [8, 11, 12]
    if (y.includes(this.selectGpStatus)) {
      if (this.step == 2) {
        this.step = 3
        this.updateWelcomeScreen(3)
      } else {
        this.updateWelcomeScreen(4)
        this.step = 4

      }
    } else {
      if (x.includes(this.selectGpStatus)) {
        this.updateWelcomeScreen(3)
        this.step = 3
      }

      else {
        this.updateWelcomeScreen(4)
        this.step = 4

      }

    }
    this.getUserExamSchedulingDetails()
    this.getExamSchedulingDetails(this.selectGpStatus)


  }
  updateExamStatus(modal) {
    let payload = []

    if (this.audData) {
      // date_of_exam: "Oct-2023",
      // this.audData.date_of_exam = "Oct-2023" // 2023-08   22-Nov-2023

      payload.push(
        { ...this.filterThePyload(this.audData) })

    } if (this.becData) {
      payload.push({ ...this.filterThePyload(this.becData) })
    } if (this.farData) {
      payload.push({ ...this.filterThePyload(this.farData) })

    }
    if (this.regData) {
      payload.push({ ...this.filterThePyload(this.regData) })

    }
    if (this.audData.dropdownInfo.exam_status_id == 4 && (this.audData.score <= 75 || this.audData.score > 100)) {
      this.audData.checkscore = "Score should be between 75 to 100";
    }
    else if (this.becData.dropdownInfo.exam_status_id == 4 && (this.becData.score <= 75 || this.becData.score > 100)) {
      this.becData.checkscore = "Score should be between 75 to 100";

    } else if (this.farData.dropdownInfo.exam_status_id == 4 && (this.farData.score <= 75 || this.farData.score > 100)) {
      this.farData.checkscore = "Score should be between 75 to 100";

    } else if (this.regData.dropdownInfo.exam_status_id == 4 && (this.regData.score <= 75 || this.regData.score > 100)) {
      this.regData.checkscore = "Score should be between 75 to 100";
    }
    else {

      this.gamePlanService.updateLandingExamScheduling(payload).subscribe((res: any) => {
        if (res && res.status) {
          this.getUserExamSchedulingDetails(),
            this.updateWelcomeScreen(5)

        } else {
          this.showErrorPopup = 2
          this.examErrorMsg = res.message
          if (this.examErrorMsg !== '') {
            modal.show()
          }
        }
      })
    }
  }




  convertToDatetag(dateString) {
    const arr = dateString.split(/-| /);
    const monthNames = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    if (arr.length > 2) {
      // 22 - oct - 2023

      const monthNumber = this.dp.transform(monthNames.indexOf(arr[1]) + 1, '2.0')
      return `${arr[2]}-${monthNumber}-${arr[0]}`;
    } else {
      // aug - 2023

      const monthNumber = this.dp.transform(monthNames.indexOf(arr[0]) + 1, '2.0')
      return `${arr[1]}-${monthNumber}`;
    }
  }
  getMonthAbbreviation(monthNumber) {
    const monthNames = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    return monthNames[monthNumber - 1];
  }
  filterThePyload(obj) {
    let dropdownInfoStatus = obj.dropdownInfo.exam_status_id
    let x = [1, 2, 5]
    let y = [3, 4, 6]
    let convertDate
    if (x.includes(dropdownInfoStatus)) {
      // 2023 - 08 sample Date
      if (obj.date_of_exam !== '' && obj.date_of_exam !== null && obj.date_of_exam !== undefined) {
        // console.log(obj.date_of_exam, 'if')
        const date1 = obj.date_of_exam;
        const [year1, month1] = date1.split('-');
        convertDate = `${this.getMonthAbbreviation(month1)}-${year1}`;
      }
      else {
        convertDate = obj.date_of_exam
      }
    } else if (y.includes(dropdownInfoStatus)) {
      // 2023 - 07 - 22 sample date
      if (obj.date_of_exam !== '' && obj.date_of_exam !== null && obj.date_of_exam !== undefined) {
        const date2 = obj.date_of_exam;
        const [year2, month2, day2] = date2.split('-');
        convertDate = `${day2}-${this.getMonthAbbreviation(month2)}-${year2}`
      }
      else {
        convertDate = obj.date_of_exam
      }
    }

    let payload = {
      id: obj.id,
      subject_id: obj.subject_id,
      date_of_exam: convertDate,
      exam_status: dropdownInfoStatus,
      score: obj.score,
      nts_expire_date: obj.nts_expire_date
    }
    // console.log(payload)
    return payload
  }




  checkGpStatus(modal: any) {
    this.gamePlanService.checkLandingGpStatus({ gameplanCurrentStatus: this.selectGpStatus }).subscribe((res: any) => {
      if (res && res.status) {
        this.showGPModal = res.data[0].success
        this.userType = res.data[0].userType
        this.allowUpdate = res.data[0].allowUpdate
        this.enableArrowButton = true
        this.gpErrorMsg = res.message
        this.showErrorPopup = 1
        if (this.gpErrorMsg !== '') {
          modal.show()
        }
      } else {
        this.enableArrowButton = true
        this.showErrorPopup = 1
        this.selectGpStatus = this.previousGpstatus
        this.gpErrorMsg = res.message
        if (this.gpErrorMsg !== '') {
          modal.show()
        }
      }
    })


    // if (this.selectGpStatus) {
    //   console.log(this.selectGpStatus, 'selectGpStatus')
    // } 

  }
  updateCurrentGpStatus() {
    if (this.allowUpdate != 1 && this.allowUpdate != undefined) {
      let payload = {
        userType: this.userType,
        isNotify: this.showGPModal,
        gameplanCurrentStatus: this.selectGpStatus
      }
      this.gamePlanService.updateLandingGpStatus(payload).subscribe((res: any) => {
        if (res && res.status) {


          this.appearedExamScreen()


        }
        // else {
        //   modal.show()

        //   this.commonErrorMsg = "something went wron try again!!"

        // }
      })
    }
    else {
      this.appearedExamScreen()

    }

  }
  selectErrorGpPopup(modal: any) {
    // this.loadLottieAnimation()
    // this.commonErrorMsg = "Kindly select any field"
    modal.show()

  }
  // selectErrorExamPopup() {
  //   console.log('Please select any field')


  // }
  // selectErrorConfirmExamPopup() {
  //   console.log('Please select any field')


  // }
  checkExamStatus() {
    if (this.selectGpStatus) {
      console.log(this.selectGpStatus, 'selectGpStatus')
      this.enableArrowButton = true
    } else {
      this.enableArrowButton = false
    }

  }

  //   navigateToGpStatus(){
  //     if(this.isWelcome == 4){
  // this.updateWelcomeScreen(2)
  //     }else{
  //       this.updateWelcomeScreen(2)


  //     }
  //   }


  updateWelcomeScreen(step: number) {
    this.step = step
    this.loginService.updateWelcomeStatus({ isWelcome: step }).subscribe((res: any) => {
      if (res && res.status) {
        if (step == 1) {
          this.router.navigateByUrl('/godfather-start-page');
        } else if (step == 5) {
          this.router.navigateByUrl('/godfather-last-page');
        }
        else {
          // if (this.selectGpStatus == 0) {
          //   this.enableArrowButton = false
          //   console.log(this.selectGpStatus, 'this.selectGpStatus');

          // }
          // console.log(step)
          this.isWelcome = step
        }

      }
    })
  }

  disableClick(event: Event) {
    event?.stopPropagation();
  }


  showBelowFormHandler(name: any, id: any) {
    // console.log(name, id, 'show')
    var firstCard = document.getElementById(name);
    firstCard?.classList.add('hoverCard');
    var behindCard = document.getElementById(id);
    behindCard?.classList.add('zIndexCard');

    if (id === 101) {
      this.selectExamStatus = this.audData.dropdownInfo.exam_status
    }
    else if (id === 102) {
      this.selectExamStatus = this.becData.dropdownInfo.exam_status

    }
    else if (id === 103) {
      this.selectExamStatus = this.farData.dropdownInfo.exam_status

    } else if (id === 104) {
      this.selectExamStatus = this.regData.dropdownInfo.exam_status

    }
  }

  hideBelowFormHandler(name: any, id: any) {
    // console.log(name, id, 'hide')

    var firstCard = document.getElementById(name);
    firstCard?.classList.remove('hoverCard');
    var behindCard = document.getElementById(id);
    behindCard?.classList.remove('zIndexCard');
    if (id === 101) {
      this.selectExamStatus = this.audData.dropdownInfo.exam_status
    }
    else if (id === 102) {
      this.selectExamStatus = this.becData.dropdownInfo.exam_status

    }
    else if (id === 103) {
      this.selectExamStatus = this.farData.dropdownInfo.exam_status

    } else if (id === 104) {
      this.selectExamStatus = this.regData.dropdownInfo.exam_status

    }


  }

  // localStorage.setItem('subjectId', 'c53f9b7df8fbb22dc12d0e859a5c9734');

  loadLottieAnimation() {
    const animationDataUrl =
      'https://assets5.lottiefiles.com/packages/lf20_e1pmabgl.json';
    const containerElement = document.getElementById(
      'error-lottie'
    ) as HTMLElement;
    const animationConfig: AnimationConfigWithPath = {
      container: containerElement,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: animationDataUrl,
    };
    (lottie as any).loadAnimation(animationConfig);
  }

  showSubjectCard(subjectId) {
    if (subjectId == 101) {
      this.audData.prioritizeWarning = false

    } else if (subjectId == 102) {
      this.becData.prioritizeWarning = false

    } else if (subjectId == 103) {
      this.farData.prioritizeWarning = false

    } else if (subjectId == 104) {
      this.regData.prioritizeWarning = false

    }
  }











  // loadLottieAnimation2() {
  //   const animationDataUrl =
  //     'https://assets1.lottiefiles.com/private_files/lf30_rvoz2xj8.json';
  //   const containerElement = document.getElementById(
  //     `alert-lottie-img`
  //   ) as HTMLElement;
  //   const animationConfig: AnimationConfigWithPath = {
  //     container: containerElement,
  //     renderer: 'svg',
  //     loop: true,
  //     autoplay: true,
  //     path: animationDataUrl,
  //   };
  //   (lottie as any).loadAnimation(animationConfig);
  // }

}
